module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch7aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch7a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch7"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("CANDY HOLIDAYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Hallmark swears there’s no such thing as “Hallmark holidays”: holidays created solely for the purpose of selling more greeting cards. But what about “candy holidays”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")]), _c('b', [_vm._v("WEETEST DAY (third Sunday in October)")]), _vm._v(" Billed as a “Second Valentine’s Day” in the early 1920s, Sweetest Day was invented by 12 Cleveland candy companies that wanted to create a holiday around the giving of candy to orphans, shutins, the homeless, and other people unlikely (or unable) to buy it for themselves. Their Sweetest Day of the Year committee distributed nearly 20,000 boxes of free candy, hoping to jump-start the holiday and spread it nationwide. No dice: It’s still observed in the Great Lakes region, but never caught on anywhere else.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1s"
  }, [_c('span', [_c('b', [_vm._v("JAPANESE VALENTINE’S DAY (February 14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("It was introduced to Japan in the 1950s by a chocolate-company executive who was trying to increase February sales. Because he didn’t understand how Valentine’s Day worked in the West, he set it up so that "), _c('i', [_vm._v("women")]), _vm._v(" gave candy to "), _c('i', [_vm._v("men,")]), _vm._v(" a practice that continues to this day.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1s"
  }, [_c('span', [_c('b', [_vm._v("WHITE DAY (March 14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("A few years after Valentine’s Day was brought to Japan, a marshmallow company created White Day to increase sales of "), _c('i', [_vm._v("their")]), _vm._v(" product. It worked: Today, chocolate given by women to male acquaintances on Valentine’s Day is called "), _c('i', [_vm._v("giri-choco")]), _vm._v(" (“obligation chocolate”), and the recipient is expected to reciprocate with marshmallows or other gifts one month later on White Day.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("CANDY DAY (second Saturday in October)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Invented in 1916 when Halloween trick-or-treating was still a local—not a national—phenomenon, Candy Day was an attempt by the National Confectioners Association to spur sales during the slow months leading up to Christmas. We might still be celebrating Candy Day today, had the United States’ entry into World War I not forced the cancellation of the 1917 festivities. Attempts to revive it after the war were unsuccessful.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("The gym on the "), _c('i', [_vm._v("Titanic")]), _vm._v(" included a mechanical camel.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c591b6fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter007.vue
// module id = 99
// module chunks = 0